import { createRouter, createWebHistory, NavigationGuard, RouteRecordRaw } from "vue-router";

import Dashboard from "../views/Dashboard.vue";
import PedidosSync from "../views/Pedidos.vue";
import Pedidos from "../views/Pedidos.vue";
import Pedido from "../views/PedidoDetalhe.vue";

import RomaneioRelatorio from "../views/Romaneio.vue";
import Romaneio from "../views/Romaneio.vue";




import Monitoramento from "../views/Monitoramento.vue";

import TempoReal from "../views/TempoReal.vue";

import Rapida from "../views/RotasRapida.vue";


import Operacoes from "../views/Operacoes.vue";
import Usuarios from "../views/Usuarios.vue";



import Veiculos from "../views/Veiculos.vue";
import Motoristas from "@/views/Motoristas.vue";

import UnidadeTransporte from "@/views/UnidadeTransporte.vue";

import NovaRota from "@/views/forms/rotas/FormularioNovaRota.vue";

import Veiculo from "../views/Veiculos.vue";

import Produtos from "../views/Produtos.vue";

import Lojas from "../views/Lojas.vue";
import Chaves from "../views/Chaves.vue";
import Baners from "../views/Baners.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Signout from "../views/Signout.vue";

import store from '../store'
import PedidosLocalizacao from "@/views/PedidosLocalizacao.vue";
import PedidosHistorico from "@/views/PedidosHistorico.vue";

import Rotas from "../views/Rotas.vue";

import RotasTimeline from "@/views/RotasTimeline.vue";
import RotasGerencia from "@/views/RotasGerencia.vue";
import RotasHistorico from "@/views/RotasHistorico.vue";
import Configuracao from "../views/Configuracao.vue";
import Permissao from "../views/Permissao.vue";
import RotasMapa from "@/views/RotasMapa.vue";


import Picking from "../views/Picking.vue";


const privateRoute: NavigationGuard = function(to, from, next) {

  if (!store.state.user.isAuthenticated) {
    next({ name: 'Signin' });
  } else {

    if(to.meta && to.meta.role){
     
      if(to.meta.role == store.state.user.userRole){
        next();
      }else{
        next({ name: 'Permissao' });
      }
            
    }else{
      next();
    }
    
  }
};

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: privateRoute
  },
  {
    path: "/pedidos/localizacao",
    name: "Localizacão",
    component: PedidosLocalizacao,
    beforeEnter: privateRoute
  },
  {
    path: "/pedidos/historico",
    name: "Histórico",
    component: PedidosHistorico,
    beforeEnter: privateRoute
  },
  {
    path: "/pedidos/:id",
    name: "Pedido",
    meta: { breadcrumb: [{"text":"Pedidos", path:"/pedidos"}] }, 
    component: Pedido,
    beforeEnter: privateRoute
  },
  {
    path: "/pedidos",
    name: "Pedidos",
    component: Pedidos,
    beforeEnter: privateRoute
  },
  {
    path: "/picking",
    name: "Picking",
    component: Picking,
    beforeEnter: privateRoute
  },
  {
    path: "/romaneios/:id",
    name: "Romaneio Relatorio",
    component: RomaneioRelatorio,
    beforeEnter: privateRoute
  },
  {
    path: "/romaneios",
    name: "Romaneios",
    component: Romaneio,
    beforeEnter: privateRoute
  },
  {
    path: "/rotas/timeline",
    name: "TimeLine",
    component: RotasTimeline,
    beforeEnter: privateRoute
  },
  {
    path: "/rotas/historico",
    name: "Historico",
    component: RotasHistorico,
    beforeEnter: privateRoute
  },
  {
    path: "/rotas/criar",
    name: "Nova Rota",
    component: NovaRota,
    beforeEnter: privateRoute
  },
  {
    path: "/rotas",
    name: "Rotas Mapa",
    component: RotasMapa,
    beforeEnter: privateRoute
  },
  {
    path: "/rotas/gerencia",
    name: "Rotas Gerencia",
    component: RotasGerencia,
    beforeEnter: privateRoute
  },
  {
    path: "/monitoramento",
    name: "Monitoramento",
    component: Monitoramento,
    beforeEnter: privateRoute
  },
    {
    path: "/temporeal",
    name: "Tempo Real",
    component: TempoReal,
    beforeEnter: privateRoute
  },
    {
    path: "/rapida",
    name: "Rapida",
    component: Rapida,
    beforeEnter: privateRoute
  },
  {
    path: "/operacoes",
    name: "Operacoes",
    component: Operacoes,
    beforeEnter: privateRoute
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    component: Usuarios,
    beforeEnter: privateRoute
  },
  {
    path: "/usuarios/:id",
    name: "Novo Usuarios",
    component: Usuarios,
    beforeEnter: privateRoute
  },
  {
    path: "/veiculos/:id",
    name: "Novo Veiculo",
    component: Veiculo,
    beforeEnter: privateRoute
  },
  {
    path: "/veiculos",
    name: "Veiculos",
    component: Veiculos,
    beforeEnter: privateRoute
  },
  {
    path: "/motoristas/:id",
    name: "Novo Motoristas",
    component: Motoristas,
    beforeEnter: privateRoute
  },
  {
    path: "/motoristas",
    name: "Motoristas",
    component: Motoristas,
    beforeEnter: privateRoute
  },
  {
    path: "/unidades/:id",
    name: "Novo Unidade",
    component: UnidadeTransporte,
    beforeEnter: privateRoute
  },
  {
    path: "/unidades",
    name: "Unidades de Trasporte",
    component: UnidadeTransporte,
    beforeEnter: privateRoute
  },
  {
    path: "/lojas",
    name: "Lojas",
    component: Lojas,
    beforeEnter: privateRoute
  },
  {
    path: "/chaves",
    name: "Chaves",
    component: Chaves,
    beforeEnter: privateRoute
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    beforeEnter: privateRoute
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
    beforeEnter: privateRoute
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
    beforeEnter: privateRoute
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    beforeEnter: privateRoute
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
    {
    path: "/signout",
    name: "Signout",
    component: Signout,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/permissao",
    name: "Permissao",
    component: Permissao,
  },
  {
    path: "/configuracoes",
    name: "Configuração",
    meta: {"role":"master"},
    component: Configuracao,
    beforeEnter: privateRoute
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
